<template>
  <div class="quick-translate-page">
    <div style="margin-bottom: 0" class="module">
      <div class="content">
        <div class="create-content">
          <textarea class="left" style="resize: none"> </textarea>
          <div class="right">
            <div class="title bold">重要提示：</div>
            <p>
              1.本公司推出"快译"是为了方便客户分析下注，为了避免给自己带来没有必要的损失，敬请各位客户务必
            </p>
            <p style="margin-bottom: 10px">
              检查确认后再下注!由于精度没有做到百分百(我们一直在努力!)。<span
                class=""
                >公司一切以下注明细为准</span
              >，如有不便，希望各位会员谅解!
            </p>
            <p style="margin-bottom: 10px">2.快译规则说明</p>
            <p>
              3.每条规则中会去掉重复的号码4.五星(前二、后二、首尾)请在输入的每行内容前面添加字母"w"
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="module">
      <div class="title">生成号码明细</div>
      <div class="content">
        <div class="create-detail">
          <div
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <input style="margin-right: 23px" class="input left" type="text" />
            <button style="margin-right: 23px" class="btn primary">
              立即下注
            </button>
            <button style="margin-right: 23px" class="btn plain">清空</button>
            <button style="margin-right: 51px" class="btn plain">追号</button>
            <span style="margin-right: 50px"
              >总注数：<span class="active-text">0</span></span
            >
            <span>总金额：<span class="active-text">0</span></span>
          </div>
          <table style="width: 100%" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th v-for="item in 12" :key="item">号码</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="12" style="background: transparent; height: 250px">
                  <div class="noData"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.quick-translate-page {
  .create-content {
    height: 300px;
    display: flex;
    // align-items: center;
    .left {
      margin: 10px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 3;
      border: none;
      border: 1px solid var(--primary-table-border-color);
      border-radius: 4px;
      outline: none;
    }
    .right {
      text-align: left;
      padding: 20px;
      padding-bottom: 50px;
      flex: 2;
      > .title {
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
  }
  .create-detail {
    padding: 20px;
    table {
      border: 1px solid var(--primary-table-border-color);
      th,
      td {
        height: 30px;
        line-height: 30px;
        padding: 0 20px;
        text-align: center;
        &:not(:last-child) {
          border-right: 1px solid var(--primary-table-border-color);
        }
      }
      tr {
        &:not(:last-child) {
          border-bottom: 1px solid var(--primary-table-border-color);
        }
      }
    }
  }
  .input {
    width: 91px;
    height: 26px;
  }
}
</style>
